import { $ } from './../../helpers/query';
import Swiper from 'swiper/bundle';

export default () => {

  $('.maps').each(section => {

    const carousel = $('.maps__carousel', section);
    const navigation = $('[data-move-to]', section);

    const swiper = new Swiper(carousel.elem, {
      allowTouchMove: false,
      effect: 'fade',
      on: {
        init: () => {
          navigation.elem.classList.add('maps__btn--active');
        }
      }
    });

    navigation.on('click', (e, btn) => {
      const index = btn.getAttribute('data-move-to') - 1;
      swiper.slideTo(index);
      navigation.removeClass('maps__btn--active');
      btn.classList.add('maps__btn--active');
    })

  });

}
